/**
 * Renaissance Tea : barre de progression vers la livraison offerte.
 *
 * Le rendu initial est fait en Liquid (snippets/rt-free-shipping-bar.liquid) et le tiroir
 * re-rend son en-tête à chaque ajout, suppression ou changement de quantité. Ce script
 * couvre en plus les chemins qui ne re-rendent pas cette zone (page /cart, ajouts depuis
 * une carte produit) : à chaque événement cartUpdate du thème, il met à jour toutes les
 * barres [data-rt-fsb] avec le panier renvoyé, ou relit /cart.js si l'événement ne
 * contient pas un panier complet.
 */
(function () {
  'use strict';

  if (window.rtFreeShippingBar) return;

  function formatNumber(value, decimals, thousandsSep, decimalSep) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return decimals ? parts[0] + decimalSep + parts[1] : parts[0];
  }

  function formatMoney(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}}€';
    var value = (cents || 0) / 100;
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = formatNumber(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = formatNumber(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = formatNumber(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        out = formatNumber(value, 2, ' ', ',');
        break;
      default:
        out = formatNumber(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function isFullCart(data) {
    return !!data && typeof data.total_price === 'number' && typeof data.item_count === 'number' && Array.isArray(data.items);
  }

  function render(cart) {
    var bars = document.querySelectorAll('[data-rt-fsb]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) continue;

      // Seuls les articles à expédier comptent (pas les cartes cadeaux).
      var total = 0;
      var shippable = 0;
      for (var k = 0; k < cart.items.length; k++) {
        if (cart.items[k].requires_shipping) {
          total += cart.items[k].final_line_price;
          shippable++;
        }
      }
      var remaining = threshold - total;
      var progress = Math.min(100, Math.max(0, Math.floor((total * 100) / threshold)));
      var state = cart.item_count === 0 ? 'is-empty' : shippable === 0 ? 'is-none' : remaining <= 0 ? 'is-reached' : 'is-progress';

      bar.classList.remove('is-empty', 'is-progress', 'is-reached', 'is-none');
      bar.classList.add(state);
      bar.hidden = state === 'is-none';
      bar.style.display = state === 'is-none' ? 'none' : '';

      var amount = bar.querySelector('[data-rt-fsb-remaining]');
      if (amount) amount.textContent = formatMoney(Math.max(0, remaining), bar.getAttribute('data-money-format'));

      var fill = bar.querySelector('.rt-fsb__fill');
      if (fill) fill.style.width = progress + '%';

      var track = bar.querySelector('.rt-fsb__track');
      if (track) track.setAttribute('aria-valuenow', String(progress));
    }
  }

  var pending = null;

  function refresh(data) {
    if (!document.querySelector('[data-rt-fsb]')) return;
    if (isFullCart(data)) {
      render(data);
      return;
    }
    if (pending) return;
    pending = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (isFullCart(cart)) render(cart);
      })
      .catch(function () {})
      .then(function () {
        pending = null;
      });
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        refresh(event && event.cartData);
      });
    }
    // Page /cart : la suppression d'une ligne (cart-remove-button, assets/cart.js) re-rend la
    // liste mais plante ensuite avant de publier cartUpdate (bug existant : main-cart-footer
    // n'a pas de .js-contents). On relit donc le panier dès que la liste change.
    var pageItems = document.getElementById('main-cart-items');
    if (pageItems && 'MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          refresh(null);
        }, 150);
      }).observe(pageItems, { childList: true, subtree: true });
    }
    // Retour arrière (cache de page) : le panier a pu changer dans un autre onglet.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh(null);
    });
  }

  window.rtFreeShippingBar = { refresh: refresh, formatMoney: formatMoney };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
